import { PropertyListStatsTealiumImpressionsFactory } from './impressions.factory';
import { PropertyListStatsTealiumImpressionsStore } from './impressions.store';

const service = PropertyListStatsTealiumImpressionsFactory();

export function PropertyListStatsTealiumImpressionsService(): PropertyListStatsTealiumImpressionsStore {
  return service;
}
